import React, { useState } from "react";
import BaseBage from "../BasePage";
import { getETA } from "../../api/FlaskAPI";
import etaLegend from "../../assets/images/eta_legend.png";
import MonitoringDialog from "../Masking/MonitoringDialog";
import Map from "../Masking/Map";
import CoordinatesInput from "../../components/CoordinatesInput";
import NavPageSelector from "../../components/NavPageSelector";
import SignInComponent from "../../components/Sign/SignComponent";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function ETA() {
  const [open, setOpen] = useState(false);
  const areas = useSelector((state) => state.mapState.areas);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <BaseBage
        dataKey="ETA"
        monitoringKey="eta"
        route="ETA"
        legendImg={{ src: etaLegend, style: "eta-legend-img" }}
      />
      {/* <div className="monitoring-container">
        <div className="map-wrapper">
          <NavPageSelector route={"masking"} />
          <div className="sign-up-container-base">
            <SignInComponent
              menuIconColor="black"
              backgroundColor="white"
              MT="0em"
              ML="0em"
              classN="modalcontainer-base"
            />
          </div>
          <CoordinatesInput disableFileUpload={false} />

          <Map />

          {/* side modal
          <div className="submit-compare-buttons-container">
            <button
              className="submit-compare-buttons"
              onClick={() => {
                if (!areas || !areas[0] || !areas[0].coordinates) {
                  toast.error(
                    "Please select the polygon you want to be predicted"
                  );
                } else {
                  handleOpen();
                }
              }}
            >
              Monitoring
            </button>
            <MonitoringDialog
              mainIndex="NDVI"
              open={open}
              handleClose={handleClose}
            />
          </div>
        </div>
      </div> */}
    </>
  );
}
